<script lang="ts" setup>
withDefaults(
  defineProps<{
    isEnabled?: boolean;
    labelText?: string;
  }>(),
  {
    isEnabled: false,
    labelText: '',
  }
);

// emits
const emits = defineEmits<{
  (e: 'onToggled', isEnabled: boolean): void;
}>();
</script>

<template>
  <div class="toggle-switch">
    <span class="toggle-switch__label" :class="{ 'toggle-switch__label--enabled': isEnabled }">{{ labelText }}</span>
    <div class="toggle-switch__switch" @click="emits('onToggled', !isEnabled)">
      <input type="checkbox" class="toggle-switch__switch__checkbox" />
      <div
        class="toggle-switch__switch__slider"
        :class="{ 'toggle-switch__switch__slider--enabled': isEnabled, 'toggle-switch__switch__slider--disabled': !isEnabled }"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.toggle-switch {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  &__label {
    font-family: Noto Sans JP;
    font-size: 14px;
    line-height: 14px;
    font-weight: 700;
    margin-right: 8px;

    &--enabled {
      color: $semanticPrimary;
    }
  }
  &__switch {
    $switch_width: 60px;
    position: relative;
    display: inline-block;
    width: $switch_width;
    height: 34px;

    &__checkbox {
      display: none;
    }

    &--vtouch {
      width: 100%;
      height: 100%;
    }

    &__slider {
      $slider_margin: 4px;
      $slider_size: 26px;
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      border-radius: 34px;

      &:before {
        content: '';
        position: absolute;
        height: $slider_size;
        width: $slider_size;
        transition: 0.4s;
        border-radius: 50%;
        background-color: white;
      }

      &--disabled {
        background-color: #ccc;
        &:before {
          left: $slider_margin;
          bottom: $slider_margin;
        }
      }

      &--enabled {
        background-color: #2196f3;
        &:before {
          left: ($switch_width - ($slider_size + $slider_margin));
          bottom: $slider_margin;
        }
      }
    }
  }
}
</style>
